import TaskHeaderViewer from "./task/components/TaskHeaderViewer";
import TaskHeaderEditor from "./task/components/TaskHeaderEditor";
import TaskHeader2 from "./task/components/TaskHeader2";
import TaskMini from "./task/components/TaskMini";
import TaskShortHand from "./task/components/TaskShortHand";
import TaskDashRow from "./task/components/TaskDashRow";
import TaskDashImageRow from "./task/components/TaskDashImageRow";
import Workflow from "./task/components/Workflow";
import WorkFlowLogEditor from "./task/components/WorkFlowLogEditor";

import ProjectTimesheet from "./components/ProjectTimesheet"
import ProjectTimesheetRow from "./components/ProjectTimesheetRow"
import ProjectHoldResumeEditor from "./components/ProjectHoldResumeEditor"
import ProjectHoldHistory from "./components/ProjectHoldHistory"

import cmnViewMap from '../cmn/Index';
import systemViewMap from '../system/Index';
import invViewMap from "../inv/Index";

const taskViewMap = {
    "vTaskHeaderViewer": TaskHeaderViewer,
    "vTaskHeaderEditor": TaskHeaderEditor,
    "vTaskHeader2":TaskHeader2,
    "vTaskMini":TaskMini,
    "vTaskShorthand":TaskShortHand,
    "vTaskDashRow":TaskDashRow,
    "vTaskDashImageRow":TaskDashImageRow,
    "vProjectTS":ProjectTimesheet,
    "vProjectTSRow":ProjectTimesheetRow,
    "vProjectHoldResumeEditor":ProjectHoldResumeEditor,
    "vProjectHoldHistory":ProjectHoldHistory,
    "vWorkFlow":Workflow,
    "vWorkFlowLogEditor":WorkFlowLogEditor,

    ...invViewMap,
    ...cmnViewMap,
    ...systemViewMap
}

export default taskViewMap;